import { CheckboxModule } from 'primeng/checkbox';
import { AutoCompleteCompleteEvent, AutoCompleteModule } from 'primeng/autocomplete';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslatePipe } from '@ngx-translate/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { UserService } from '#services';
import { Component, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { catchError, of } from 'rxjs';

export interface UserSearchDialogConfig {
  onSelectUser(userEmail: string): Promise<unknown>;
}

@Component({
  selector: 'app-user-search-dialog',
  imports: [CheckboxModule, AutoCompleteModule, SelectModule, TranslatePipe, ReactiveFormsModule],
  templateUrl: './user-search-dialog.component.html',
  styleUrl: './user-search-dialog.component.scss',
})
export class UserSearchDialogComponent {
  private _destroyRef = inject(DestroyRef);
  private _ref: DynamicDialogRef<UserSearchDialogComponent> = inject(DynamicDialogRef);
  private _config: DynamicDialogConfig<UserSearchDialogConfig> = inject(DynamicDialogConfig);
  private _userService = inject(UserService);

  formGroup = new FormGroup({
    userEmail: new FormControl<string>('', { validators: [Validators.required] }),
  });

  searchUserByEmail({ query = '' }: AutoCompleteCompleteEvent) {
    this._userService
      .searchUser(query)
      .pipe(
        catchError(() => of([])),
        takeUntilDestroyed(this._destroyRef)
      )
      .subscribe(data => {
        this.suggestions.set(data.map(d => d.email));
      });
  }

  cancel() {
    this._ref.close();
  }
  suggestions = signal<string[]>([]);

  get userEmail() {
    return this.formGroup.get('userEmail');
  }

  selectUser() {
    const { userEmail = '' } = this.formGroup.value;
    this._config.data?.onSelectUser(userEmail!).then(() => this._ref.close(true));
  }
}
